export default {
  data() {
    return {
      templates: [
        { label: 'Passport' },
        { label: 'Birth Certificate' },
        { label: 'Australian Citizenship' },
        { label: 'Visa' },
        { label: 'Course / Training' },
        { label: 'Verification of Competency' },
        { label: 'Driver Licence' },
        { label: 'Work Licence' },
        { label: 'White Card' },
        { label: 'Covid 19 Certificate' },
      ],
    }
  },
}
